import * as types from "../actions/actionTypes";

const initialState = {
  categories: [],
  category: null,
};

const category = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CATEGORY_RESPONSE: return { ...state, category: action.payload };
    case types.GET_ALL_CATEGORY_RESPONSE: return { ...state, categories: action.payload };

    case types.CREATE_CATEGORY: return { ...state, category: null };
    case types.UPDATE_CATEGORY: return { ...state, category: null };
    case types.DELETE_CATEGORY: return { ...state, category: null };
    default:
      return state;
  }
};

export default category;
